import { Navigate } from "react-router-dom";
import { useEnabledModules } from "@/hooks/useEnabledModules";
import { NotificationTriggersPage } from "@/pages/settings/NotificationTriggersPage";

/**
 * `/settings/notifications` (Phase SC-22e). Communications is the one home
 * for notification triggers, so tenants with that module are sent there.
 * Tenants without it keep the settings page so the triggers stay reachable.
 */
export function NotificationTriggersSettingsRoute() {
  const { isModuleEnabled, isLoading } = useEnabledModules();
  if (isLoading) return null;
  if (isModuleEnabled("communications")) return <Navigate to="/communications" replace />;
  return <NotificationTriggersPage />;
}
